import ArrowLeft16 from '@carbon/icons-react/es/arrow--left/16';
import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import ZoomIn16 from '@carbon/icons-react/es/zoom--in/16';
import ZoomOut16 from '@carbon/icons-react/es/zoom--out/16';
import { SwitchProps, Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { AutoAllocate16 } from 'components/atoms/icons/auto-allocate';
import { Switch } from 'components/atoms/switch/switch';
import { Text01 } from 'components/styles';

const Wrapper = styled.div`
  margin-right: var(--spacing-05);
`;
const ButtonGroup = styled.div`
  margin-left: var(--layout-03);
  display: flex;
  align-items: center;
`;

interface Props {
  shiftNext: () => void;
  shiftPrevious: () => void;
  zoomIn: () => void;
  zoomOut: () => void;
}

export const Toolbar: FC<Props> = ({
  shiftNext,
  shiftPrevious,
  zoomIn,
  zoomOut,
}) => {
  return (
    <Wrapper>
      <ButtonGroup>
        <Tooltip title={<FormattedMessage id="zoom_out" />}>
          <Button type="text" icon={<ZoomOut16 />} onClick={zoomOut} />
        </Tooltip>
        <Tooltip title={<FormattedMessage id="zoom_in" />}>
          <Button type="text" icon={<ZoomIn16 />} onClick={zoomIn} />
        </Tooltip>
        <Tooltip title={<FormattedMessage id="shift_previous" />}>
          <Button type="text" icon={<ArrowLeft16 />} onClick={shiftPrevious} />
        </Tooltip>
        <Tooltip title={<FormattedMessage id="shift_next" />}>
          <Button type="text" icon={<ArrowRight16 />} onClick={shiftNext} />
        </Tooltip>
      </ButtonGroup>
    </Wrapper>
  );
};

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  ${Text01};
`;
const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

export const AutoAllocateSwitch: FC<SwitchProps> = (props) => {
  return (
    <Tooltip
      title={
        <FormattedMessage id="templates.resource_management.autofill.hint" />
      }
      placement="bottom"
    >
      <ToggleWrapper>
        <Switch size="small" {...props} />
        <TextWrapper>
          <AutoAllocate16 />
          <FormattedMessage id="autofill" />
        </TextWrapper>
      </ToggleWrapper>
    </Tooltip>
  );
};
